"use strict";
exports.__esModule = true;
exports.ROLLOVER_CONTENT = void 0;
exports.ROLLOVER_CONTENT = {
    ROLLOVER_RENT_TRACKER: {
        MAIN_TEXT: "You have an outstanding balance with Flex",
        SUB_TEXT: 'Pay off your {{rentAmount}} balance from {{previousMonth}} by {{cutoffDate}} to use Flex for your {{currentMonth}} rent.'
    }
};
